export default "__VITE_ASSET__Cr8J3Eqf__"